var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTool = function SvgIconTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.25,
    d: "M20.99 20.32c0 .27-.141.598-.55.968s-1.038.732-1.867 1.05c-1.652.632-3.978 1.036-6.578 1.036s-4.926-.404-6.58-1.037c-.828-.317-1.455-.679-1.865-1.049S3 20.59 3 20.32s.14-.599.55-.969 1.037-.732 1.866-1.049c1.653-.632 3.979-1.036 6.579-1.036s4.926.404 6.579 1.036c.828.317 1.456.679 1.865 1.05.41.37.55.698.55.968Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.625 19.37a.625.625 0 1 1-1.25 0zm-1.25 0v-10h1.25v10z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.375,
    stroke: "inherit",
    strokeWidth: 1.25,
    transform: "matrix(-1 0 0 1 17 0)"
  })));
};
export default SvgIconTool;